import { ApiResponse } from 'apisauce';

import { ExportJobCreateResult } from '@/Modules/MyFilesModule/shared/types/export-job.type';
import { FinanceApplicationReportTablePayload } from '@/Modules/ReportsModule/FinanceApplicationReport/shared/types/finance-application-report-payload.type';
import debugConfig from '@/shared/config/debug.config';
import api from '@/shared/config/http.config';
import { ErrorInfo } from '@/shared/interfaces/error-info.interface';
import { FinanceApplicationReportResponseModel, ResponseModel } from '@/shared/interfaces/response-model.interface';
import { FinanceApplicationsReportModel } from '@/shared/models/finance-application-report.model';
import financeApplicationsReportFixtureService from '@/shared/services/fixtures/finance-applications-report/finance-applications-report-api.service';

const apis = {
  searchFinanceApplicationsReport: (
    searchFinanceApplicationReport: FinanceApplicationReportTablePayload
  ): Promise<
    ApiResponse<FinanceApplicationReportResponseModel<FinanceApplicationsReportModel[]>, ErrorInfo>
  > =>
    api.post(
      '/customerApplicationData/financeApplicationCases/search',
      searchFinanceApplicationReport
    ),
  exportFinanceApplicationsReport: (
    exportFinanceApplicationReport: Pick<FinanceApplicationReportTablePayload, 'query' | 'sort'>
  ): Promise<ApiResponse<ResponseModel<ExportJobCreateResult>, ErrorInfo>> =>
    api.post(
      '/customerApplicationData/financeApplicationCases/export',
      exportFinanceApplicationReport
    )
};

// TODO: Enhance the way of mocking APIs
export const financeApplicationsReportApi = debugConfig.useFixtures
  ? financeApplicationsReportFixtureService
  : apis;
